export class AppConstants {
    static readonly APP_NAME = 'eps';
    static readonly SESSION_VAR_USER = 'user';
    static readonly SESSION_VAR_TOKEN = 'auth_token';

    static readonly SESSION_VAR_TAGS = 'tags';
    static readonly SESSION_VAR_SEGMENTS = 'tags';
    static readonly SESSION_VAR_AREA = 'area';
    static readonly SESSION_VAR_DEPARTMENT = 'department';
    static readonly SESSION_VAR_KITCHEN = 'kitchen';
    static readonly SESSION_VAR_UOM = 'uom';
    static readonly SESSION_VAR_STOCK = 'stock';
    static readonly SESSION_VAR_CATEGORY = 'category';
    static readonly SESSION_VAR_SHOP = 'shops';
    static readonly SESSION_VAR_ITEM_CATEGORY = 'item_category';
    static readonly SESSION_VAR_EMPLOYEE_CATEGORY = 'employee_category';
    static readonly SESSION_VAR_SALE_ITEMS = 'sale_items';
    static readonly SESSION_VAR_SYSTEM_PARAM = 'system_param';
    static readonly SESSION_VAR_CUST_SALE_ITEMS = 'cust_sale_items';
    static readonly SESSION_VAR_COMBO_SALE_ITEMS = 'combo_sale_items';
    static readonly SESSION_VAR_SALE_ITEM_CUST_OPTS = 'sale_item_cust_opts';
    static readonly SESSION_VAR_SALE_ITEM_COMBO_OPTS = 'sale_item_combo_opts';
    static readonly SESSION_VAR_KITCHENS = 'kitchens';
    static readonly SESSION_VAR_CLASSES = 'item_classes';
    static readonly SESSION_VAR_TAXES = 'taxes';
    static readonly SESSION_VAR_UOMS = 'uoms';
    static readonly SESSION_VAR_GROUP_ITEMS = 'group_items';



    static readonly MASTER_ID_MULTI_FACTOR = 1000000;

    static readonly UASER_TYPE_HQ = 'HQ';
    static readonly UASER_TYPE_SHOP = 'SHOP';
    static readonly UASER_TYPE_AREA_MANAGER = 'AREA_MANAGER';







};
export const SESSION_VAR_STATE = 'page_state';

